import { Component, Inject, Input } from '@angular/core';
import { SharedAsideFactory } from '@shared/src/components/aside/shared.aside.factory';
import { ForkliftRouteDetailDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftRouteDetailDto';
import { SmsAsideDto } from '@shared/src/dtos/sms/SmsAsideDto';
import { HardmanProducts } from '@shared/src/enums/HardmanProducts';
import { HomeController } from '@shared/src/public-api';

@Component({
    selector: 'shared-forklift-right-route-header',
    templateUrl: './shared.forklift.right.route.header.component.html',
    styleUrls: ['./shared.forklift.right.route.header.component.scss']
})
export class SharedForkliftRightRouteHeaderComponent {

    public hasSMS: boolean = false;
    constructor(@Inject('SharedAsideFactory') private sharedAsideFactory: SharedAsideFactory,
        @Inject('HomeController') public homeController: HomeController) {
    }

    private _detail: ForkliftRouteDetailDto | null = null;
    @Input()
    public set detail(v: ForkliftRouteDetailDto) {
        if (v == this._detail)
            return;
        this._detail = v;
        this.wellCome();
    }
    public get detail(): ForkliftRouteDetailDto | null {
        return this._detail;
    }

    private wellCome() {

        this.hasSMS = this.homeController.hasProduct(HardmanProducts.sms);
        this.hasSMS = this.hasSMS && !!this.detail?.driverPhone;
    }


    public get phoneHref(): string | null {
        if (!this.detail?.driverPhone)
            return null;
        return 'tel:' + this.detail.driverPhone;
    }

    public openSms() {
        if (!this.detail?.driverPhone)
            return;
        this.sharedAsideFactory.invokeSms(SmsAsideDto.build(this.detail.driverPhone, true, '', false));
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }
}
